export const SETTING_FEEDBACK_ACTION = 'SETTING_FEEDBACK_ACTION';
export const SETTING_FEEDBACK_SUCCESS_ACTION =
  'SETTING_FEEDBACK_SUCCESS_ACTION';
export const SETTING_FEEDBACK_FAILURE_ACTION =
  'SETTING_FEEDBACK_FAILURE_ACTION';
